export const DE = {
  message: {
    banner:
      "Aufgrund eines technischen Problems können nicht alle Daten veröffentlicht werden. Wir arbeiten daran und entschuldigen uns für die Unannehmlichkeiten.",
    in: "Im Jahr",
    loadingText: "Wird geladen... Bitte warten",
    selectCustomer: "einen Klienten auswählen",
    offline: "Website in Wartung",
    refer: "Siehe die GEBRAUCHSANLEITUN",
    error: {
      userNotFound: "Benutzer wurde nicht gefunden",
      noToken: "Dieser Link ist nicht mehr gültig",
    },
    alert: {
      mail: "Enable mail notification",
      sms: "Enable SMS notification",
      battery: "Batteriewarnungen",
      disclamer:
        "die auf von Akiem Leasing festgelegten Schwellenwerten basieren und Lokomotiven betreffen, die mit Railster-Boxen ausgestattet sind",
      sralert: "Alarm",
      toggleAlert:
        "Wenn Sie diese Option aktivieren, erhalten Sie eine E-Mail für jede übermittelte Nachricht aus MyFleetHub",
      quotation: "Quotation alert",
      quotationLabel:
        "Wenn Sie diese Option aktivieren, erhalten Sie eine E-Mail-Benachrichtigung für jedes neues Angebot, das auf MyFleetHub veröffentlicht wird.",
    },
    select: "Alle wählen",
    ssoLogin: "Anmelden mit Azure AD",
    rgpd:
      "Akiem verpflichtet sich zur angemessenen und transparenten Beachtung der Gesetzgebung zum Schutz personengebundener Daten, " +
      "insbesondere der  Datenschutz-Grundverordnung (DSGVO). Wir verwenden auf diesem Portal keine Cookies. Während Ihrer Verbindung mit" +
      " dem Portal  werden weder personengebundene Daten von Ihnen gesammelt noch werden sie nach Ihrem Portalbesuch gespeichert. Falls Sie " +
      "die Funktionalität « Zufriedenheitsumfrage » nutzen wollen, bitten wir Sie ausdrücklich um Ihre entsprechende Zustimmung.",
    login: {
      welcomeFirst: "Willkomen",
      welcomeSecond: "auf Ihrem Kundenportal",
      id: "Login",
      pw: "Passwort",
      restore: "Mein Passwort rücksetzen",
      validate: "Einloggen",
      errorLogin: "Passwort ist falsch. Bitte versuchen Sie es erneut.",
      initMsg:
        "Bitte geben Sie Ihr Passwort ein, um die Erstellung Ihres Kontos abzuschließen",
    },
    aside: {
      home: "Startseite",
      notice: "Gebrauchsanleitung",
      logout: "Ausloggen",
      config: "Configuration",
      account: "Mein Konto",
      profil: "Profilinfos",
      alert: "Meine Meldungen",
      parc: "Meine Flotte",
      planning: "Meine Planung",
      detail: "Details meiner Flotte",
      geo: "Meine Lokomotiven - GPS Standort",
      board: "Dashboard",
      km: "Verfolgung der Km",
      hm: "Motorbetriebsstunden",
      battery: "Battery info",
      mint: "My MINT",
      magic: "Instandhaltungsübersicht",
      history: "Historie",
      infoloc: "Lok Informationen",
      fleetcontrol: "Lokfleet",
      unleased: "Nicht gemietete Flotte",
      doc: "Meine Dokumente",
      edl: "Zustandsberichte / Zertifikate",
      certificat: "Zertifikate",
      jobplan: "Wartungsfälligkeiten",
      krefeldplan: "Krefeld plan",
      batterytable: "Latest battery readings",
      geofencing: "Geofencing",
      disponibility: "Vertragliche Verfügbarkeit",
      admin: "Internal menu",
      locoInternal: "Ein Hotline-Ticket erstellen",
      userlist: "Benutzerliste",
    },
    superuser: {
      profile: "Profil",
      action: "Aktion",
      updateprofile: "Profiländerung",
      administrator: "Administrator",
      management: "Management",
      operational: "Betrieblich",
      commercial: "Geschäftlich",
      delmessage1: "Sie sind dabei, die Löschung des Kontos",
      delmessage2:
        "zu beantragen. Eine Nachricht wird an die IT-Abteilung von Akiem gesendet, die das Konto löschen wird.",
      delmessage3:
        "wird keinen Zugang mehr zum My Fleet Hub Kundenportal haben. Wenn der Benutzer zu einem späteren Zeitpunkt erneut ein Konto erstellen möchte, sollte er sich an seinen Servicevertragsmanager wenden.",
      legendmgt:
        "Das Managementprofil kann alle Module des Portals einsehen. Es kann zusätzliche extraworks validieren.",
      legendcom:
        "Das Verkaufsprofil kann alle Module des Portals abrufen. Es kann keine extraworks validieren.",
      legendoper:
        "Das operative Profil kann alle Portalmodule mit Ausnahme des Moduls « my extraworks » einsehen.",
    },
    geofencing: {
      select: "Bitte wählen Sie einen Wert",
      entry: "Eintrittsdatum und -uhrzeit",
      exit: "Datum und Uhrzeit der Ausfahrt",
      dbenergy: "Haben Sie daran gedacht, Ihre DB Energy abzugeben?",
    },
    header: {
      language: "Sprachen",
    },
    home: {
      team: "Meine Akiem-kontaktpersonen",
      name: "Name",
      firstname: "Vorname",
      function: "Funktion",
      fixphone: "Festnetznummer",
      mobilephone: "Mobilnummer",
      mail: "E-mail",
      locoInfo: "Erstellen Sie eine schnelle Serviceanfrage",
    },
    page: {
      assignment: "Zuweisung",
      customer: "Kunde",
      portal: "Portal",
      availableLoco: "Aufrechterhalten durch AKIEM",
      loconumber: "Lokomotivnummer",
      status: "Betriebsstatus",
      available: "einsatzbereit",
      maintenance: "in Wartung",
      connexionDate: "Datum des letzten Logins",
      findLocation: "Den Standort der Lokomotiven finden",
      contractNumber: "Vetragsnummer",
      serial: "series",
      contractStatus: "Vertragstatus",
      startDate: "Startdatum",
      endDate: "Enddatum",
      delta:
        "Durch die Auswahl einer einzelnen Lokomotive erhalten Sie das Layout Ihrer Strecke",
      locate: "Lokalisierung",
      titular: "Titular",
      reserve: "Reserve",
      spot: "Spot",
      performance: "Leistung",
      cumulTitle: "Kumulierte Kilometer pro Lokomotive",
      cumul: "Kumulierte km",
      distance: "Distanz",
      moyMonth: "Durchschnitt der gefahrenen KM / Monat",
      filterMsg:
        "Durch die Auswahl einer einzelnen Lokomotive erhalten Sie das Layout Ihrer Strecke",
      availableNotice: '"Enthält keine Ausschreibungen im Konto"',
      doctype: "Art des Dokuments",
      contractType: "Contract type",
    },
    opinionGlobal: {
      opinion: "Meine meinung zum Portal",
      opinionFirst: "Meine Meinung",
      opinionSecond: "Zum Portal",
      opinionRedirectionOne:
        "Sie werden auf einer externen Website weitergeleitet,",
      opinionRedirectionTwo: "Wollen Sie fortsetzen ?",
      opinionClic:
        "Durch Klicken auf diesen Link erklären Sie sich damit einverstanden, dieses Portal zu verlassen, um auf die Eval N Go-Plattform für diese Zufriedenheitsumfrage zuzugreifen, " +
        "und stimmen Sie mit der Verarbeitung Ihrer persönlichen Daten zu.",
      opinionPersonelData:
        "Die erhobenen personenbezogenen Daten lauten wie folgt :",
      opinionMail: "Ihre E-mail",
      opinionName: "Ihr Name",
      opinionDataTransmission:
        "Diese Daten werden nur an von Akiem autorisierte Personen weitergegeben, die der Vertraulichkeitspflicht unterliegen, " +
        "und werden 1 Jahr lang aufbewahrt.",
      opinionStock:
        "Es wird in Frankreich gehostet und nicht außerhalb der EU übertragen.",
      opinionRules:
        "In Übereinstimmung mit dem geltenden Gesetz haben Sie das Recht, Ihre persönlichen Daten (Zugriffsrecht, Berichtigung usw.) zu kontrollieren, " +
        "die Sie durch Senden einer E-Mail an dpo@akiem.com ausüben können.",
      opinionHelp:
        "Dies hilft uns, weitere Fortschritte in der Art und Weise zu erzielen, wie wir Sie unterstützen, und um Ihre Bedürfnisse besser zu verstehen, " +
        "your contribution would be a great help deshalb wäre Ihr Beitrag eine große Hilfe.",
      opinionYes: "Ja",
      opinionNo: "Nein",
    },
    pageKm: {
      trackingKm: "Verfolgung der Km",
      tableKm: "Kilometerstand",
      status: "Vertragliche Lage",
      serial: "Seriennummer",
      contract: "Verträge",
      contractnum: "Vertragsnummer",
      total: "Gesamtstrecke",
      loco: "Lokomotiven",
      date: "Datum",
      since: "schon seit",
      kmNotice: '"Erfasste Kilometer nach den übermittelten Railster-Daten" ',
    },
    pageHm: {
      title: "Motorbetriebsstunden",
      lastcheck: "Letzte Daten",
      cumulativeHm: "Kumulative Motorbetriebsstunden",
      hm: "Triebwerksstunden",
      total: "Gesamte verbrauchte Motorbetriebsstunden",
      portalReal: "über das Portal erfasste Messwerte",
      maintenanceReal: "während der Wartung gemessene Werte",
      detailHm: "Angaben zu den Motorbetriebsstunden",
    },
    maintenance: {
      workshops: "Wartungswerkstätte",
    },
    pageAlert: {
      alert: "Meine Alarmen",
      inout: "EIN- UND AUSGANG LOKOMOTIVE",
      serial: "auf Serie",
      contract: "auf Vetrag/zum Vertrag/vertraglich",
      loco: "auf den Lokomotiven in meiner Flotte",
      mail: "Mail-Alarm aktivieren",
      sms: "SMS-Alarm aktivieren",
      battery: "BATTERIE-BERICHT",
    },
    passwordResetPage: {
      first:
        "Bitte geben Sie Ihren Benutzernamen und Ihr Passwort ein, um die Erstellung Ihres Kontos abzuschließen",
      confirm: "Passwort Bestätigung",
      pwRuleOne: "Passwort erforderlich",
      pwRuleTwo: "mindestens 8 Zeichen",
      pwRuleThree:
        "Das Passwort muss mindestens Kleinbuchstaben, eine Zahl, ein Sonderzeichen und einen Großbuchstaben enthalten",
      pwConfirmOne: "Passwortbestätigung ist erforderlich",
      pwConfirmTwo: "Passwortbestätigung stimmt nicht überein",
      pwSuccess: "Passwort zurücksetzen mit Erfolg",
      validate: "bestätigen",
    },
    pageNotice: {
      second:
        "Die auf dem Portal bereitstehenden und/oder über dieses Portal abrufbaren Daten, Informationen und/oder Dokumente werden ausschließlich" +
        " zur Information veröffentlicht und haben keinerlei vertraglichen Wert.",
      third:
        "Die Daten, Informationen und/oder Dokumente können Unrichtigkeiten und Fehler enthalten. Es steht Akiem jederzeit frei, sie zu ändern und" +
        " zu aktualisieren. Wir empfehlen dringend, die Richtigkeit und Relevanz der auf diesem Portal bereitstehenden Daten, Informationen und/oder Dokumente  zu überprüfen.",
      fourty:
        "Die Verwendung der Daten, Informationen und/oder Dokumente des Portals erfolgt unter umfassender und ausschließlicher Verantwortung des Portalnutzers, der alle" +
        " sich daraus möglicherweise ergebenden Konsequenzen vollumfänglich trägt; Akiem kann deswegen in keiner Weise haftbar gemacht werden und jedweder Regress gegen Akiem ist ausgeschlossen.",
      fifty:
        "Akiem haftet für keinerlei Schäden jeglicher Art, wobei es nicht darauf ankommt, ob diese sich aus einer Auslegung oder aus der Nutzung der " +
        "auf diesem Portal bereitstehenden  Daten, Informationen und/oder Dokumente  ergeben.",
      sixty:
        "Das Portal ist in der Regel rund um die Uhr aufrufbar, d.h. 24h/24h täglich 7d/7d, mit Ausnahme von Fällen Höherer Gewalt oder Ereignissen, " +
        "die sich der Kontrolle von Akiem entziehen, sowie vorbehaltlich eventuell eintretender Pannen und Wartungsmaßnahmen, wie sie für den " +
        "einwandfreien Betrieb des Portals für Nutzer mit Internetzugang erforderlich sind. Akiem behält sich die Möglichkeit vor, den Zugriff " +
        "auf das Portal jederzeit ohne Vorankündigung zeitweilig ganz oder teilweise für Wartungsmaßnahmen oder aus jedem sonstigen Grund zu unterbrechen, " +
        "ohne dass aus der Unterbrechung irgendwelche Verpflichtungs- oder Schadensersatzansprüche entstehen könnten.",
      seventy:
        "Akiem verpflichtet sich zur angemessenen und transparenten Beachtung der Gesetzgebung zum Schutz personengebundener Daten, insbesondere der  " +
        "Datenschutz-Grundverordnung (DSGVO). Akiem hat entsprechende technische und organisatorische Maßnahmen zum Schutz der Nutzerdaten gegen unbefugte " +
        "Zugriffe sowie gegen alle sonstigen IT-Sicherheits- und –Anfälligkeitsrisiken  getroffen.",
      eighty:
        "Wir verwenden auf diesem Portal keine Cookies. Während Ihrer Verbindung mit dem Portal  werden weder personengebundene Daten von Ihnen gesammelt " +
        "noch werden sie nach Ihrem Portalbesuch gespeichert. Falls Sie die Funktionalität « Zufriedenheitsumfrage » nutzen wollen, bitten wir Sie " +
        "ausdrücklich um Ihre entsprechende Zustimmung.",
    },
    magic: {
      workorderTitle: "Korrektivmaßnahme",
      workorder: "Workorder",
      startDate: "Startdatum",
      endDate: "Enddatum",
      meter: "Kilometerstand",
      hours: "Stunden",
      technicDoc: "Technische Dokumentation",
      restriction: "Restriction/Reason",
      date: "Datum",
      asset: "Asset",
      km: "KM",
      leftD1: "Left D1",
      leftD2: "Left D2",
      leftD3: "Left D3",
      leftD4: "Left D4",
      rightD1: "Right D1",
      rightD2: "Right D2",
      rightD3: "Right D3",
      rightD4: "Right D4",
      action: "Action",
      description: "Beschreibung - Standort",
      desc: "Beschreibung",
      addFile: "Dokument hinzufügen",
      reportBy: "Berichtet von",
      id: "ID",
      status: "Status",
      sr: "Lok-Notiz",
      srAttechement: "Angehängte Berichte",
      attachements: "Anhänge",
      mileage: "Kilometerstand aktualisieren",
      createAlert: "Lok-Notiz erstellen",
      title: "Titel",
      location: "Standort",
      priority: "Priorität",
      addKm: "Kilometer eintragen",
      newKm: "Neuer Kilometerstand",
      lastreading: "Aktueller Kilometerstand",
      scheduleDate: "Geplantes Datum",
      metername: "Art der Ablesung",
      executeDate: "Durchführungsdatum",
      error: "Operation fehlgeschlagen",
      success: "Erfolgreiche Operation",
      attachment: "eine Anlage hinzufügen",
      unit: "Einheit",
      source: "Quelle",
      jobplan: "Beschreibung",
      type: "Typ",
      reportedDate: "Erstellungsdatum",
      details: "Details",
      hotline: "Hotline-Ticket",
    },
    assetStatus: {
      operating: "Operating",
      maintenance: "Maintenance",
      limitedUse: "limited use",
      blocked: "Blocked",
    },
    button: {
      submit: "Prüfen",
      cancel: "STORNIEREN",
    },
    search: "Suche",
    history: {
      pm: "präventive Instandhaltung",
      cm: "korrektive Instandhaltung",
    },
    infoloc: {
      infoOp: "Operative Informationen",
      infoTech: "Technische Informationen",
      cert: "Zulassung",
      openSr: "Offene Ausschreibungen",
      sr: "Ausschreibungen",
      dateAndKm: "Daten und Kilometerstand",
      pmPlan: "Vorausschauender Wartungsplan",
      locomotive: "Lokomotiven",
      actWorkorder: "in Wartung",
      outPrevDate: "Voraussichtliches veröffentlichungsdatum",
      nextWorkDate: "Nächste Wartung",
      wheelset: "Raddurchmesser",
      unitToGo: "Restkilometer",
      engineeringvariant: "Engineering variant",
      softwareversion: "Software version",
      hkm: "Kilometerverlauf",
      hhm: "Motorstundenverlauf",
      fuellevel: "Fioulpegel",
      parking: "außer Betrieb",
      traction: "in Bewegung - selbständig",
      vehicle: "in Bewegung - geschleppt",
      poweron: "unter Spannung, ohne Bewegung",
      standby: "Dieselmotor an, ohne Bewegung",
    },
    status: {
      approved: "Confirmed appointment",
      canceled: "Stestornieren",
      ccanceled: "Appointment canceled by customer",
      completed: "Status gemäß der Entscheidung von ECM 3",
      inprogress: "Under maintenance",
      wait: "forcast planing, upcoming maintenance",
      new: "Neu",
      sinprogress: "In bearbeitung",
      closed: "Verschließen",
    },
    woStatus: {
      WSCH: "In Planung",
      WAPPR: "In Planung",
      WPCOND: "In Planung",
      CLOSE: "Abgeschlossen",
      COMP: "Abgeschlossen",
      INPRG: "In Bearbeitung",
      REVIEWED: "Durchgeführt / ECM3 Freigabe ausstehend",
      WCOE: "Betreiberfreigabe ausstehend",
      WMATL: "Warten auf Material",
      APPR: "Durch ECM4 bestätigt",
      CA: "Abgesagt",
      NOTPERF: "Nicht durchgeführt / abgeschlossen",
      CAN: "Abgesagt",
    },
    doc: {
      certificat: {
        delivry: "DELIVERY",
        redelivry: "RÜCKGABEBESCHEINIGUNG",
        genralInfo: "ALLGEMEINE INFORMATIONEN",
        technicalInfo: "TECHNISCHE ANGABEN",
        signature:"UNTERZEICHNUNGEN",
        asOf:"Mit Datum vom ",
        andAccording: "und gemäß den Bestimmungen",
        contractRes: "im ABRUFVERTRAG/Reservierung*  ",
        representBy:"Akiem SAS (frz. Kapitalgesellschaft in vereinfachter Form), nachfolgend der LEASINGGEBER, vertreten durch Sebastian Rodriguez",
        delivryTo: "übergibt der Gesellschaft",
        society:"die Gesellschaft",
        lessee: "  (nachfolgend der LEASINGNEHMER)",
        delivryToAkm:"lieferte an das Unternehmen Akiem, vertreten durch Sebastian Rodriguez ",
        locomotive: "die Lokomotive",
        locoType: "Lokomotivtyp",
        delivryAt: "geliefert an den Lieferungsort von ",
        redelivryAt:"redelivered to the Place of Redelivery of:",
        restDerog:"Ausnahmegenehmigung / Einschränkungen",
        comment:"Bemerkungen ",
        edl:"Bestandsaufnahme der Lokomotive in der Anlage [ja/nein]",
        remark:"Hinweis",
        rem1:"Vorbehaltlich der vertraglichen Bestimmungen muss die Lokomotive spätestens ab dem in der Lieferbescheinigung genannten Lieferdatum versichert sein.",
        rem2:"Der Besitz der Lokomotive wird am in dieser Lieferbescheinigung genannten Lieferdatum von dem LEASINGGEBER auf den LEASINGNEHMER übertragen.",
        kmCompteur: "Km Zähler",
        hmMoteur: "Motorstunden",
        wheelset: "Achsen",
        recentData: "neueste Angaben*",
        subjectTo: "*Vorbehaltlich der Bestandaufnahme der Lokomotive, falls verfügbar.",
        lastRecord: "letzten Messwerte am",
        date:"Datum",
        defaultMes:"Wenn innerhalb von 48 Stunden kein Vorbehalt eingegangen ist, gilt diese Lieferbescheinigung als endgültig.",
        addBill:"Zusätzliche Kosten für die Instandsetzung der Lokomotive können gegebenenfalls in Rechnung dem LEASINGNEHMER gestellt werden..",
        yes: "JA",
        no: "NEIN",
        reserv: "Einen Vorbehalt einlegen",
        reject: "Vorbehalte erteilt"
      },
      type: "Art des Dokuments",
      edl: {
        delivry: "Standortstatus der lieferung",
        redelivry: "Stand der rückgabe ",
      },
    },
    doctypes: [
      {
        key: "DELIVERY (EXCEPT NEW)",
        value: "Standortstatus der lieferung",
      },
      {
        key: "REDELIVERY,RESTITUTION",
        value: "Stand der rückgabe",
      },
      {
        key: "Prima Delivery Certificate,Traxx Delivery Certificate",
        value: "Zertifikate für die lieferung",
      },
      {
        key: "Prima Redelivery Certificate,Traxx Redelivery Certificate",
        value: "Bescheinigungen über die rückgabe",
      },
    ],
    poi: {
      workshop: "Eingänge/Ausgänge Workshops",
      entry: "Voraussichtliche Einreise am",
      exit: "Voraussichtliche Ausfahrt am",
      at: "um",
    },
    extrawork: {
      title: "Meine extraworks",
      newquote: "Neue Angebote",
      quotewaiting: "Warten auf Bestätigung",
      messageconfirm: "Bitte geben Sie Ihre Bestellnummer an",
      confirm: "Bestätigen",
      reject: "Ablehnen",
      cancel: "Stornieren",
      whyreject: "Warum möchten Sie das Angebot ablehnen?",
      rejectcomment: "Bitte hinterlassen Sie einen Kommentar",
      quotenum: "Angebot Nr.",
      quotetitle: "Titel des Angebots",
      quoteprice: "Preis ohne MwSt.",
      quotestatus: "Status des Angebots",
      realisationdate: "Tatsächliche Realisierung",
      customerpo: "Kunde Po",
      tovalidate: "Warten auf Bestätigung",
      validated: "Angenommen",
      rejected: "Abgelehnt",
      quoterejected: "Abgelehnt",
      quotesrejected: "Abgelehnte Kostenvoranschläge",
      comment: "Kommentar",
      unitprice: "Einheitspreise",
      service: "Dienstleistungen",
      quantity: "Menge",
      totalprice: "Gesamtpreis",
      quotetotalprice: "Gesamtkosten des Angebots",
      statusbilled: "in Rechnung gestellt",
      statusvalidated: "freigegeben",
    },
    dispoc: {
      past: "Sehe frühere Zuweisungen",
      widgetText: "Meine vertragliche Verfügbarkeit ansehen",
      taux: "Quote",
      recapLoc: "Verfügbarkeit",
      ticmp: "Präventive Ausfallquote",
      timcc: "Quote der korrektiven Ausfallzeiten",
      ticc: "Kundenausfallquote",
      locDisp: "Verfügbar",
      locTot: "Gesamt",
      week: "Woche",
      ldispo: "Verfügbar",
      ldmd: "V. Verschlechtertem Zustand",
      lmp: "Präventive Wartung",
      lmc: "Korrektive Wartung",
      lach: "Routing",
      lmcc: "Korrektive Wartung Kunde",
      indisponibilite: "Unverfügbarkeit",
      dispGen: "Globale Verfügbarkeit",
      causeCorrective: "korrektive Wartung",
      causePreventive: "präventive Wartung",
      causeClient: "vom Kunden",
    },
    restriction: {
      title: "Beschränkung in",
      partial: "Teilweise Beschränkung",
      total: "Vollständige Beschränkung",
      dates: "Vom {start} bis {end}",
    },
  },
  country: {
    AT: "Österreich",
    BE: "Belgien",
    CH: "Schweiz",
    CZ: "Tschechische Republik",
    DE: "Deutschland",
    DK: "Dänemark",
    FR: "Frankreich",
    HR: "Kroatien",
    HU: "Ungarn",
    IT: "Italien",
    LU: "Luxemburg",
    MA: "Marokko",
    NL: "Niederlande",
    PL: "Polen",
    RO: "Romänien",
    SE: "Schweden",
    SK: "Slowakei",
    SI: "Slowenien",
    RS: "Serbien",
  },
};

export default DE;
